<template>
  <div>
    <main role="main">
      <div class="page-content">
        <div class="container py-md-5 py-4">
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <div class="row align-items-center mb-4">
                <div class="col-md-6">
                  <h2 class="page-title mb-md-0 mb-3">
                    <a
                      class="cursor-pointer"
                      v-on:click="$router.push('/dashboard')"
                      ><img
                        src="/images/back-arrow.svg"
                        width="20"
                        alt=""
                        class="me-2"
                    /></a>
                    My Activity
                  </h2>
                </div>
                <div class="col-md-6 text-end"></div>
              </div>

              <ul
                class="nav nav-pills mb-3 tab-style-1"
                id="login-tab"
                role="tablist"
                style="height: 100px"
              >
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    role="tab"
                    style="height: 100px"
                    v-on:click="$router.push('/recently-viewed')"
                    >Recently Viewed <br />profiles ({{
                      count.recently_view_count >= 0
                        ? count.recently_view_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    role="tab"
                    style="height: 100px"
                    v-on:click="$router.push('/shortlisted')"
                    >Shortlisted <br />({{
                      count.shortlisted_count >= 0
                        ? count.shortlisted_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/intrest-sent')"
                    >Interest Sent <br />({{
                      count.intrest_sent_count >= 0
                        ? count.intrest_sent_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/intrest-recieved')"
                    >Interest Received <br />({{
                      count.intrest_recieved_count >= 0
                        ? count.intrest_recieved_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link activ"
                    style="height: 100px"
                    v-on:click="$router.push('/contacts-viewed')"
                    >Viewed Contacts <br />({{
                      count.viewed_contact_count >= 0
                        ? count.viewed_contact_count
                        : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/blocked-users')"
                    >Blocked Users<br />({{
                      count.block_count >= 0 ? count.block_count : " "
                    }})</a
                  >
                </li>
                <li class="nav-item cursor-pointer" role="presentation">
                  <a
                    class="nav-link"
                    style="height: 100px"
                    v-on:click="$router.push('/reported-users')"
                    >Reported Users<br />({{
                      count.report_count >= 0 ? count.report_count : " "
                    }})</a
                  >
                </li>
              </ul>

              <div class="tab-content form-style">
                <!-- TAb 6 Viewed Contact -->

                <div
                  class="tab-pane fade show active"
                  id="tab_5"
                  role="tabpanel"
                  aria-labelledby=""
                >
                  <div
                    class="border-top pt-4"
                    v-for="(data, index) in ViewdContact"
                    :key="index"
                  >
                    <div class="row">
                      <div class="col-lg-3 col-md-4 mb-4 position-relative">
                        <div
                          :id="'ProfileSlider2_' + index"
                          class="carousel slide profile-sider"
                          data-bs-ride="carousel"
                          data-bs-interval="false"
                        >
                          <div
                            class="carousel-inner rounded-l cursor-pointer"
                            v-if="
                              data.user.user_images.length > 0 ||
                              data.user.user_images != null
                            "
                          >
                            <div
                              class="carousel-item"
                              v-for="(data1, index1) in data.user.user_images"
                              :key="index1"
                              :class="index1 == 0 ? 'active' : ' '"
                            >
                              <img
                                :src="
                                  data1.image
                                    ? data1.image
                                    : 'img/profile-holder.png'
                                "
                                class="photos"
                                alt="..."
                              />
                            </div>
                          </div>
                          <div
                            class="carousel-inner rounded-l new cursor-pointer"
                            v-if="
                              data.user.user_images.length == 0 ||
                              data.user.user_images == null
                            "
                          >
                            <div class="carousel-item active">
                              <img
                                src="img/profile-holder.png"
                                class="photos"
                                alt="..."
                              />
                            </div>
                          </div>
                          <div v-show="data.user.user_images.length">
                            <button
                              class="carousel-control-prev"
                              type="button"
                              :data-bs-target="'#ProfileSlider2_' + index"
                              data-bs-slide="prev"
                            >
                              <span
                                class="carousel-control-prev-icon"
                                aria-hidden="true"
                              ></span>
                              <span class="visually-hidden">Previous</span>
                            </button>
                          </div>
                          <div v-show="data.user.user_images.length">
                            <button
                              class="carousel-control-next"
                              type="button"
                              :data-bs-target="'#ProfileSlider2_' + index"
                              data-bs-slide="next"
                            >
                              <span
                                class="carousel-control-next-icon"
                                aria-hidden="true"
                              ></span>
                              <span class="visually-hidden">Next</span>
                            </button>
                          </div>
                        </div>
                        <div
                          class="text-center my-3 carousel-counter"
                          id="slide-counter"
                        >
                          <div class="num text-white"></div>
                        </div>
                      </div>
                      <div
                        class="col-lg-7 col-md-8 cursor-pointer"
                        v-on:click="
                          $router.push('/profile-view/' + data.user.uuid)
                        "
                      >
                        <div class="row">
                          <div class="col-lg-6">
                            <div class="row">
                              <div class="col-6">
                                <label for="">Reg. No.</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.registration_no
                                      ? data.user.registration_no
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Surname</label>
                              </div>
                              <div
                                class="col-6"
                                style="word-break: break-all !important"
                              >
                                <p class="font-medium pink-clr">
                                  <!-- {{
                                    data.user.first_name
                                      ? data.user.first_name
                                      : ""
                                  }}
                                  {{
                                    data.user.middle_name
                                      ? data.user.middle_name
                                      : ""
                                  }} -->
                                  {{
                                    data.user.last_name
                                      ? data.user.last_name
                                      : ""
                                  }}
                                </p>
                              </div>
                            </div>

                            <!-- <div
                              class="row"
                              v-if="mydetail.is_membership_subscribed == 'N'"
                            >
                              <div class="col-6">
                                <label for="">Surname</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.last_name
                                      ? data.user.last_name
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div> -->
                            <div class="row">
                              <div class="col-6">
                                <label for="">Native Place</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user && data.user.native_place_district
                                      ? data.user.native_place_district.name
                                      : ""
                                  }}
                                  {{
                                    data.user && data.user.native_place_taluka
                                      ? " - " +
                                        data.user.native_place_taluka.name
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-6">
                                <label for="">DOB</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.dob
                                      ? $helperService.getFormatedDate(
                                          data.user.dob
                                        )
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Height</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.height
                                      ? $helperService.getHeight(
                                          data.user.height
                                        )
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            
                          </div>
                          <div class="col-lg-6">
                            <div class="row">
                              <div class="col-6">
                                <label for="">Education</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.education_courses
                                      ? data.user.education_courses
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Occupation</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.occupation_details
                                      ? data.user.occupation_details
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Ann. Inc. (Lakh)</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.annual_income ||
                                    data.user.annual_income == 0
                                      ? $helperService.kFormatter(
                                          data.user.annual_income
                                        )
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-6">
                                <label for="">Working city</label>
                              </div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{
                                    data.user.working_place_taluka
                                      ? data.user.working_place_taluka.name
                                      : "-"
                                  }}
                                </p>
                              </div>
                            </div>
                            
                            <!-- <div class="row">
                              <div class="col-6"><label for="">Gun Milan</label></div>
                              <div class="col-6">
                                <p class="font-medium">
                                  {{ data.user.gan ? data.user.gan.name : "-" }}
                                </p>
                              </div>
                            </div> -->
                          </div>
                          <!-- <div class="text-center mt-3 col-lg-12 col-sm-12">
                            <button
                              type="button"
                              class="btn btn-outline-brand-1"
                            >
                              <i class="fa fa-unlock" aria-hidden="true"></i>
                              Unlock
                            </button>
                          </div> -->
                        </div>
                      </div>
                      <div class="col-lg-2 col-md-4 ps-md-0">
                        <!-- <button
                          v-on:click="showRemmaingtactModel(data.to_user_id)"
                          class="btn btn-outline-brand-1 mb-2 w-100"
                        >
                          <i
                            class="fa fa-eye font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          View Contact
                        </button> -->
                        <button
                          v-if="!data.hasViewContact"
                          v-on:click="showRemmaingtactModel(data.to_user_id)"
                          class="btn btn-outline-brand-1 mt-2 mb-3 w-100"
                        >
                          <i
                            class="fa fa-eye font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          View Contact
                        </button>
                        <button
                          v-if="data.hasViewContact"
                          v-on:click="showRemmaingtactModel(data.to_user_id)"
                          class="btn btn-brand-1 mt-2 mb-3 w-100"
                        >
                          <i
                            class="fa fa-eye font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          View Contact
                        </button>
                        <button
                          type="button"
                          class="btn btn-brand-1 w-100 mb-2"
                          v-if="data.hasSentIntrest"
                          v-on:click="notIntrested(data)"
                        >
                          <i
                            class="fa fa-paper-plane font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          Cancel Interest
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-brand-1 mb-2 w-100 px-2"
                          v-if="!data.hasSentIntrest"
                          v-on:click="sendIntrest(data)"
                        >
                          <i
                            class="fa fa-paper-plane font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          Send Interest
                        </button>
                        <div
                          class="btn-group w-100"
                          role="group"
                          aria-label="Basic checkbox toggle button group"
                          v-if="!data.hasShortListed"
                        >
                          <input
                            type="checkbox"
                            class="btn-check"
                            :id="'btncheck' + index"
                            autocomplete="off"
                          />
                          <label
                            class="btn btn-outline-brand-1 mb-2 w-100"
                            :for="'btncheck' + index"
                            v-on:click="shortlist(data)"
                            ><i
                              class="fa fa-heart font-20 me-2"
                              aria-hidden="true"
                            ></i>
                            Shortlist</label
                          >
                        </div>

                        <button
                          type="button"
                          class="btn btn-brand-1 w-100 mb-2"
                          v-if="data.hasShortListed"
                          v-on:click="removeShortlisted(data)"
                        >
                          <i
                            class="fa fa-heart font-20 me-2"
                            aria-hidden="true"
                          ></i>
                          Shortlisted
                        </button>
                        <div class="dropdown">
                          <button
                            type="button"
                            :class="
                              data.hasBlocked || data.hasReported
                                ? 'btn-brand-1'
                                : 'btn-outline-brand-1'
                            "
                            class="btn w-100 dropdown-toggle"
                            id="dropdownMore"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <i
                              class="fa fa-ellipsis-v font-20 me-2"
                              aria-hidden="true"
                            ></i>
                            More
                          </button>
                          <ul
                            class="dropdown-menu"
                            aria-labelledby="dropdownMore"
                          >
                            <li>
                              <a
                                class="dropdown-item"
                                href="#"
                                v-on:click="showSharePopup(data.to_user_id)"
                                ><i
                                  class="fa fa-share-alt"
                                  aria-hidden="true"
                                ></i>
                                Share Profile</a
                              >
                            </li>
                            <li>
                              <a
                                class="dropdown-item cursor-pointer"
                                v-if="!data.hasBlocked"
                                v-on:click="blockUser(data)"
                                ><i class="fa fa-ban" aria-hidden="true"></i>
                                Block User</a
                              >
                            </li>
                            <li>
                              <a
                                class="dropdown-item cursor-pointer"
                                v-if="data.hasBlocked"
                                v-on:click="unblockUser(data)"
                                ><i class="fa fa-ban" aria-hidden="true"></i>
                                Unblock</a
                              >
                            </li>
                            <li>
                              <a
                                v-if="data.hasReported == 0"
                                class="dropdown-item cursor-pointer"
                                v-on:click="showReportUser(data)"
                                ><i class="fa fa-flag" aria-hidden="true"></i>
                                Report This User</a
                              >
                              <a
                                v-if="data.hasReported"
                                class="dropdown-item cursor-pointer"
                                style="color: red; font-weight: 401"
                                ><i
                                  class="fa fa-flag"
                                  aria-hidden="true"
                                  style="color: red"
                                ></i>
                                Already Reported</a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ErrorComponent
                    @retry="getViewedList(0)"
                    ref="errorComponent"
                  />
                  <div class="row mx-0 mb-4">
                    <div
                      class="col-lg-12 mt-5 text-right"
                      style="text-align-last: end"
                    >
                      <div class="page-bottom-pagination text-right">
                        <Pagination
                          @page-change="pageChange"
                          @items-per-page-change="itemsPerPageChange"
                          ref="listPagination"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <!-- View Reason  -->
    <div
      class="modal fade"
      id="ViewReason"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">View Reason</h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit.
              Perspiciatis asperiores repellat ipsa enim nobis! Dignissimos quod
              quo deserunt delectus animi perspiciatis aut, perferendis libero,
              voluptatem hic nemo quisquam iure. Vel.
            </p>
          </div>
        </div>
      </div>
    </div>

    <TextModal ref="viewMembershipPlan">
      <div>
        <div class="row col-12 px-md-5 border-0 p-4 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto; margin-top: -58px; margin-right: -10px"
              v-on:click="$refs.viewMembershipPlan.closeModal()"
            ></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">You are a free member</h4>
            <p>
              Buy a paid membership to see contact no. & some hidden information
            </p>
          </div>
          <div class="text-center">
            <router-link
              to="/membership-plans"
              class="btn btn-brand-1 btn-block"
            >
              View membership plan
            </router-link>
          </div>
        </div>
      </div>
    </TextModal>
    <TextModal ref="remainingContacts">
      <div>
        <div class="row border-0 text-align-last-center">
          <div class="col-1" style="text-align-last: end"></div>
        </div>
        <div class="modal-body pt-0 form-style">
          <div class="row">
            <button
              type="button"
              class="btn-close"
              style="margin-left: auto"
              v-on:click="$refs.remainingContacts.closeModal()"
            ></button>
          </div>
          <div class="form-group">
            <h4 class="text-center">View Contact</h4>
            <p>
              Your Total Remaining Contact View is -
              {{ remaining_contact_view_count }}
            </p>
          </div>
          <div class="text-center">
            <button
              type="button"
              class="btn btn-brand-1 w-100 mb-3"
              v-on:click="showContactModel()"
            >
              View Contact
            </button>
          </div>
        </div>
      </div>
    </TextModal>
    <TextModal ref="reportModal">
      <div class="modal-content">
        <div class="modal-header px-md-5 border-0">
          <div class="row">
            <!-- <h5 class="modal-title" id="loginModalLabel">Report</h5> -->
            <button
              type="button"
              class="btn-close"
              v-on:click="$refs.reportModal.closeModal()"
            ></button>
          </div>
        </div>
        <div class="modal-body px-4">
          <h5 class="modal-title font-22 mb-0 text-center mb-3">Report</h5>
          <Form ref="reportForm" @submit="reportUser()">
            <div class="floating-form mb-4">
              <div class="floating-form-group mt-4 mb-2" style="height: 130px">
                <Field
                  as="textarea"
                  type="text"
                  rows="4"
                  style="width: 100%;"
                  name="message"
                  rules="required:message"
                  :validateOnInput="true"
                  v-model="reportObj.message"
                />

                <label for="message"
                  >Please write your problem/suggestion</label
                >
                <span class="text-danger">*</span>
              </div>
              <ErrorMessage name="message" class="text-danger" />
            </div>
            <div class="text-center">
              <button class="btn btn-brand-1" type="submit" id="submit-button5">
                Submit
              </button>
            </div>
          </Form>
        </div>
      </div>
    </TextModal>
    <ShareModal ref="shareModal" />
    <ConteactViewModel ref="ConteactViewModel" />
  </div>
</template>
<script>
import $ from "jquery";
import ErrorComponent from "@/components/ErrorComponent";
import ConteactViewModel from "@/components/ConteactViewModel";
import Pagination from "@/components/Pagination.vue";
import TextModal from "@/components/TextModal.vue";
import ShareModal from "@/views/SocialShare/ShareModal.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
// import moment from "moment";
//import router from "../../router";
export default {
  name: "MyActivity",
  components: {
    ErrorComponent,
    ConteactViewModel,
    Pagination,
    TextModal,
    Form,
    Field,
    ShareModal,
    ErrorMessage,
  },
  data() {
    return {
      loader: false,
      uuid: "",
      remaining_contact_view_count: 0,
      offset: 0,
      count: {},
      mydetail: {},
      ViewdContact: [],
      report_id: "",
      reportObj: {},
      ViewdContact1: {},
      contentDetail: {},
      url: "",
      showingFullText: false,
      showingFullIngredients: false,
      body: "",
      ingredients: "",
      // All: this.$route.query.All,
      type: this.$route.query.type,
    };
  },

  mounted() {
    var totalItems = $(".carousel-item").length;
    var currentIndex = $(".carousel-item.active").index() + 1;
    $(".num").html("" + currentIndex + "/" + totalItems + "");

    $("#ProfileSlider").bind("slid", function () {
      currentIndex = $(".carousel-item.active").index() + 1;
      $(".num").html("" + currentIndex + "/" + totalItems + "");
    });
    this.getActivityCount();
    this.getviewedList(0);
    this.getMeCall();
  },
  methods: {
    pageChange(offset) {
      this.getviewedList(offset - 1);
    },
    itemsPerPageChange() {
      this.itemsPerPage = this.$refs.listPagination.itemsPerPage;
      this.getviewedList(0);
    },
    showSharePopup(uuid) {
      this.url = window.location.href;
      var url = this.url.replaceAll(
        "/contacts-viewed",
        "/profile-view/" + uuid
      );
      this.url = url;
      this.$refs.shareModal.showModal(this.url, "Profile");
    },
    smsEmailUserDetails(uuid) {
      this.$api
        .getAPI({
          _action: "/email-detail/" + uuid,
        })
        .then(() => {
          this.$notify({
            type: "success",
            text: "User details are successfully sent to your registered email and mobile number",
          });
          this.$refs.viewContactmodel.closeModal();
        })
        .catch(() => {});
    },
    showRemmaingtactModel(uuid) {
      this.$refs.errorComponent.updateFormLoader(true);
      if (uuid) {
        this.uuid = uuid;
      }
      this.$api
        .getAPI({
          _action: "/remmaing-contact-detail/" + this.uuid,
        })
        .then((res) => {
          this.$refs.errorComponent.updateFormLoader(false);
          if (res.contact_view && res.contact_view > 0) {
            this.remaining_contact_view_count = res.contact_view;
            this.$refs.remainingContacts.showModal();
          } else if (res.already_viewed && res.already_viewed == 1) {
            this.contentDetail = res;
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          } else {
            this.$refs.viewMembershipPlan.showModal();
          }
        })
        .catch(() => {
          this.$refs.errorComponent.updateFormLoader(false);
        });
    },
    showContactModel() {
      this.$refs.remainingContacts.closeModal();
      this.$api
        .getAPI({
          _action: "/contact-detail/" + this.uuid,
        })
        .then((res) => {
          if (res) {
            this.contentDetail = res;
            this.$refs.remainingContacts.closeModal();
            this.$refs.ConteactViewModel.showModal(this.contentDetail);
          }
        })
        .catch(() => {});
    },
    getActivityCount() {
      this.$api
        .getAPI({
          _action: "/get-activity-count",
        })
        .then((res) => {
          this.count = res;
        })
        .catch(() => {});
    },

    shortlist(data) {
      var obj = {};
      if (data.user) {
        obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      } else {
        return;
      }
      if (obj.to_user_id) {
        this.$api
          .postAPI({
            _action: "/short-list",
            _body: obj,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getActivityCount();
            return (data.hasShortListed = 1);
          })
          .catch(() => {});
      }
    },
    getMeCall() {
      this.$api
        .getAPI({
          _action: "/user/me",
        })
        .then((res) => {
          this.mydetail = res;
          this.$store.commit("setUser", res);
        })
        .catch(() => {});
    },
    sendIntrest(data) {
      var obj = {};
      obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      this.$api
        .postAPI({
          _action: "/send-intrest",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getActivityCount();
          return (data.hasSentIntrest = 1);
        })
        .catch(() => {});
    },
    notIntrested(data) {
      var obj = {};
      obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      this.$api
        .putAPI({
          _action: "/cancel-request/" + obj.to_user_id,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getActivityCount();
          return (data.hasSentIntrest = 0);
        })
        .catch(() => {});
    },
    blockUser(data) {
      var obj = {};
      obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      this.$api
        .postAPI({
          _action: "/block-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getActivityCount();
          // this.getviewedList();
          return (data.hasBlocked = 1);
        })
        .catch(() => {});
    },
    unblockUser(data) {
      var obj = {};
      obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      this.$api
        .postAPI({
          _action: "/unblock-user",
          _body: obj,
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.getActivityCount();
          return (data.hasBlocked = 0);
        })
        .catch(() => {});
    },
    reportUser() {
      this.reportObj.to_user_id = this.report_id;
      this.$api
        .postAPI({
          _action: "/report-user",
          _body: this.reportObj,
          _buttonId: "submit-button5",
        })
        .then((res) => {
          this.$notify({
            type: "success",
            text: res.message,
          });
          for (var i in this.ViewdContact) {
            if (this.ViewdContact[i].to_user_id == this.report_id) {
              this.ViewdContact[i].hasReported = 1;
            }
          }
          this.getActivityCount();
          this.$refs.reportModal.closeModal();
          this.changeTab(this.currentTab);
        })
        .catch(() => {});
    },
    removeShortlisted(data) {
      var obj = {};
      if (data.user) {
        obj.to_user_id = data.user && data.user.uuid ? data.user.uuid : "";
      } else {
        obj.to_user_id = data.uuid ? data.uuid : "";
      }
      if (obj.to_user_id) {
        this.$api
          .putAPI({
            _action: "/remove-shortlist/" + obj.to_user_id,
          })
          .then((res) => {
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.getActivityCount();
            return (data.hasShortListed = 0);
          })
          .catch(() => {});
      }
    },
    getviewedList(offset) {
      this.loader = true;
      if (this.$refs.errorComponent) {
        this.$refs.errorComponent.updateListLoader(true);
      }

      var obj = {};
      if (offset == 0) {
        this.ViewdContact = [];
      }
      obj.offset = offset;
      this.$api
        .getAPI({
          _action: "/contact-view/list",
          _body: obj,
        })
        .then((res) => {
          this.loader = false;
          this.ViewdContact = res.list;
          if (this.ViewdContact.length > 0) {
            for (var i in this.ViewdContact) {
              if (this.ViewdContact[i].user == null) {
                this.ViewdContact[i].user = {
                  user_images: [],
                };
              }
            }
          }
          this.offset = res.next_offset;
          if (offset == 0) {
            if (this.$refs.listPagination) {
              if (res.count != null && res.count > 0) {
                this.$refs.listPagination.setTotalCount(res.count);
              } else {
                this.$refs.listPagination.setTotalCount(0);
              }
            }
          }
          if (this.$refs.errorComponent) {
            this.$refs.errorComponent.setData(
              res,
              "Viewed Contact Not Available"
            );
            this.$refs.errorComponent.updateListLoader(false);
          }
          this.loader = false;
        })
        .catch(() => {
          this.loader = false;
          this.$refs.errorComponent.updateListLoader(false);
        });
    },
    showReportUser(data) {
      if (data.user) {
        this.report_id = data.user.uuid;
      }
      this.$refs.reportForm.resetForm();
      this.$refs.reportModal.showModal();
    },
  },
};
</script>
